import React from 'react'

function Security() {
  return (
    <div>

        {/* <div className="container">
          <div className="services">
            <div className="row mb-n7">
              <div className="col-sm-6 col-lg-3 mb-7">
                <div className="service-item">
                  <img className="service-icon" src="assets/images/icon/service1.png" alt="images_not_found" />
                  <h3 className="service-title">100% SECURE PAYMENTS</h3>
                  <p>Moving your card details to a much more secured place</p>
                </div>
              </div>
              <div className="col-sm-6 col-lg-3 mb-7">
                <div className="service-item">
                  <img className="service-icon" src="assets/images/icon/service2.png" alt="images_not_found" />
                  <h3 className="service-title">TRUSTPAY</h3>
                  <p>100% Payment Protection. Easy Return Policy</p>
                </div>
              </div>
              <div className="col-sm-6 col-lg-3 mb-7">
                <div className="service-item">
                  <img className="service-icon" src="assets/images/icon/service3.png" alt="images_not_found" />
                  <h3 className="service-title">HELP CENTER</h3>
                  <p>
                    GGot a question? Look no further.Browse our FAQs or submit
                    your query here.
                  </p>
                </div>
              </div>
              <div className="col-sm-6 col-lg-3 mb-7">
                <div className="service-item">
                  <img className="service-icon" src="assets/images/icon/service4.png" alt="images_not_found" />
                  <h3 className="service-title">Express Shipping</h3>
                  <p>Fast, reliable delivery from global warehouses</p>
                </div>
              </div>
            </div>
          </div>
        </div> */}
      
    </div>
  )
}

export default Security
